import Delivery from '@/dto/deliveries/Delivery'

export default function DeliveryFactory(): Delivery {
  return {
    id: null,
    currencyCode: null,

    deliveryPointType: null,
    dimensionalWeightDivisor: null,
    dpdSelfDelivery: null,
    dpdSelfPickup: null,
    dpdServiceCode: null,
    extraCostByBox: null,
    extraCostPercents: null,
    finalDeliveryId: null,
    initialDeliveryId: null,
    local: null,
    maxDays: null,
    minDays: null,
    position: null,
    postServiceCode: null,
    shipmentPointId: null,
    printableDeliveryType: null,
    deliveredDuty: '',

    name: '',
    enabled: false,
    type: '',
    calculatorType: '',
    maxHeight: 0,
    maxLength: 0,
    maxWidth: 0,
    maxWeight: null,
  }
}
